// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qa-1";
export var stateContainer = "_qa-0";